/* Smart Spaces – quick price chips for the floating filter panel.
   Uses Horizon's own <price-facet-component> so results update via Search & Discovery. */
(() => {
  document.addEventListener('click', (event) => {
    const chip = event.target instanceof Element ? event.target.closest('[data-ss-price-chip]') : null;
    if (!chip) return;

    const facet = chip.closest('price-facet-component');
    if (!facet || typeof facet.updatePriceFilterAndResults !== 'function') return;

    const minInput = facet.querySelector('[ref="minInput"]');
    const maxInput = facet.querySelector('[ref="maxInput"]');
    if (!(minInput instanceof HTMLInputElement) || !(maxInput instanceof HTMLInputElement)) return;

    const deselect = chip.getAttribute('aria-pressed') === 'true';

    // Widen the allowed ranges first so the theme does not clamp the new values to the old selection.
    const rangeMax = maxInput.getAttribute('data-max') || '';
    minInput.setAttribute('data-max', rangeMax);
    maxInput.setAttribute('data-min', '0');

    minInput.value = deselect ? '' : chip.dataset.min || '';
    maxInput.value = deselect ? '' : chip.dataset.max || '';

    facet.querySelectorAll('[data-ss-price-chip]').forEach((el) => {
      el.setAttribute('aria-pressed', String(!deselect && el === chip));
    });

    facet.updatePriceFilterAndResults();
  });
})();

/* Smart Spaces – mobile side tab: slim handle once scrolled, swipe left to close the panel. */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const SLIM_AFTER = 240;
  let ticking = false;

  const update = () => {
    ticking = false;
    const tab = document.querySelector('.ss-filter-tab');
    if (!tab) return;
    tab.classList.toggle('is-slim', mobile.matches && window.scrollY > SLIM_AFTER);
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );
  mobile.addEventListener('change', update);
  document.addEventListener('DOMContentLoaded', update);
  update();

  let startX = 0;
  let startY = 0;

  document.addEventListener(
    'touchstart',
    (event) => {
      const panel = event.target instanceof Element ? event.target.closest('#filters-drawer .ss-float') : null;
      if (!panel || !event.touches[0]) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      const panel = event.target instanceof Element ? event.target.closest('#filters-drawer .ss-float') : null;
      if (!panel || !event.changedTouches[0]) return;
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (dx < -70 && Math.abs(dy) < 50) {
        const component = panel.closest('dialog-component');
        if (component && typeof component.closeDialog === 'function') component.closeDialog();
      }
    },
    { passive: true }
  );
})();
